import { useSyncExternalStore } from 'react';

const MOBILE_MD_QUERY = '(max-width: 767px)';

const getIsMobileMd = () => {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(MOBILE_MD_QUERY).matches;
};

const subscribeToMobileMd = (onStoreChange: () => void) => {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {};

  const mediaQueryList = window.matchMedia(MOBILE_MD_QUERY);
  if (mediaQueryList.addEventListener) {
    mediaQueryList.addEventListener('change', onStoreChange);
  } else {
    mediaQueryList.addListener(onStoreChange);
  }

  return () => {
    if (mediaQueryList.removeEventListener) {
      mediaQueryList.removeEventListener('change', onStoreChange);
    } else {
      mediaQueryList.removeListener(onStoreChange);
    }
  };
};

export function useIsMobileMd() {
  return useSyncExternalStore(subscribeToMobileMd, getIsMobileMd, () => false);
}
